import React from "react"; // Required for JSX even if not explicitly used
import ClickableSettingRow from '../ClickableSettingRow'; // Adjust path
import { Button } from '@/components/ui/button';
import { useSession } from '@/hooks/useSessionHook';
import supabase from '@/supabase';
import { useNavigate } from 'react-router-dom';

interface MainSettingsProps {
    onNavigate: (view: string) => void;
}

export default function MainSettings({ onNavigate }: MainSettingsProps) {
  const { profile } = useSession();
  const navigate = useNavigate();
  const isAdmin = profile?.app_role === 'admin';

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate('/auth');
  };

  return (
    <div className="jr-screen-pad mt-4 space-y-4">
      <div className="jr-card flex flex-col overflow-hidden">
        <ClickableSettingRow label="Notification Settings" onClick={() => onNavigate('notifications')} />
        <ClickableSettingRow label="Privacy Settings" onClick={() => onNavigate('privacy')} />
        <ClickableSettingRow label="Billing Settings" onClick={() => onNavigate('billing')} />
        <ClickableSettingRow label="Communication Settings" onClick={() => onNavigate('communication')} />
        <ClickableSettingRow label="Edit Profile" onClick={() => onNavigate('edit-profile')} />
        {isAdmin && (
          <>
            <ClickableSettingRow label="Manage Bots" onClick={() => navigate('/bots')} />
            <ClickableSettingRow label="Manage Users" onClick={() => onNavigate('manage-users')} />
          </>
        )}
      </div>

      <div className="jr-card p-4">
        <Button
          variant="destructive"
          className="jr-action-danger h-auto w-full min-h-12"
          onClick={() => void handleSignOut()}
        >
          Sign out
        </Button>
      </div>
    </div>
  );
}
